module.exports = __webpack_public_path__ + "static/media/seedling.21f6ca1b.svg";